import React from 'react';

const RenderIcon = ({ children }) => {
  return (
    <div style={{ width: '40px', minWidth: '40px' }}>
      {/*<img style={{width: '27px', height: '25px'}} src="/link.png" alt="link"/>*/}
      {children}
    </div>
  );
};
export default RenderIcon;
